import { useState, useEffect } from "react";
import {
  Divider,
  Typography,
  Flex,
  Dropdown,
  Space,
  Layout,
  Menu,
  Button,
  theme,
} from "antd";
import "./App.css";
import { Main_control_section } from "./synth";
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  UserOutlined,
  HomeOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";

const { Header, Sider, Content } = Layout;
const { Title, Paragraph, Text, Link } = Typography;

const App = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  function on_menu_item_click(e) {
    console.log(e);
    alert("selected page " + e.key);
    setCurrentPage(e.key);
  }

  return (
    <Layout>
      <Sider trigger={null} collapsible collapsed={collapsed}>
        <div className="demo-logo-vertical" />
        <Menu
          theme="dark"
          mode="inline"
          defaultSelectedKeys={["1"]}
          onClick={on_menu_item_click}
          items={[
            {
              key: "1",
              icon: <HomeOutlined />,
              label: "Home",
            },
            {
              key: "2",
              icon: <UserOutlined />,
              label: "Participants",
            },
            {
              key: "3",
              icon: <InfoCircleOutlined />,
              label: "About",
            },
          ]}
        />
      </Sider>
      <Layout>
        <Header style={{ padding: 0, background: colorBgContainer }} title="">
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            style={{
              fontSize: "16px",
              width: 64,
              height: 64,
            }}
          />
        </Header>
        <Content
          style={{
            margin: "24px 16px",
            padding: 24,
            minHeight: 280,
            background: colorBgContainer,
            borderRadius: borderRadiusLG,
          }}
          id="home-page"
        >
          <Typography>
            <Title>ECE 45 Synthesizer Project</Title>
          </Typography>
          <Divider></Divider>
          <Flex gap="middle" align="start" horizontal="true">
            <Main_control_section />
          </Flex>
        </Content>
      </Layout>
    </Layout>
  );
};

export default App;
